export default __webpack_public_path__ + "static/media/books2-afterA-1024w.4a2177ae.png";